import React from "react";
import CurrencyFormat from "react-currency-format";
import { useStateValue } from "./StateProvider";
import { getBasketTotal } from "./reducer";
import { useHistory } from "react-router-dom";
import { Card, Button, Typography, Divider } from "antd";
import { CheckCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

function Subtotal() {
  const history = useHistory();
  const [{ basket }] = useStateValue();

  return (
    <Card
      style={{
        position: 'sticky',
        top: 80,
        borderRadius: 8,
        border: '1px solid #f0f0f0',
      }}
    >
      <CurrencyFormat
        renderText={(value) => (
          <>
            <Title level={4} style={{ marginBottom: 16 }}>
              Order Summary
            </Title>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <Text>Items ({basket.length}):</Text>
              <Text strong>{value}</Text>
            </div>

            <Divider style={{ margin: '16px 0' }} />

            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
              <Title level={4} style={{ margin: 0 }}>Total:</Title>
              <Title level={4} style={{ margin: 0, color: '#1890ff' }}>{value}</Title>
            </div>
          </>
        )}
        decimalScale={2}
        value={getBasketTotal(basket)}
        displayType={"text"}
        thousandSeparator={true}
        prefix={"$"}
      />

      <Button
        type="primary"
        size="large"
        block
        onClick={e => history.push('/payment')}
        icon={<CheckCircleOutlined />}
      >
        Proceed to Checkout
      </Button>
    </Card>
  );
}

export default Subtotal;
